import { render } from "./summaryreport.vue?vue&type=template&id=cfb4a5b2&scoped=true"
import script from "./summaryreport.vue?vue&type=script&lang=js"
export * from "./summaryreport.vue?vue&type=script&lang=js"

import "./summaryreport.vue?vue&type=style&index=0&id=cfb4a5b2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cfb4a5b2"]])

export default __exports__